<template>
  <div class="layout-default" v-loading="loading">
    <my-header :fixed="fixed"></my-header>

    <div
      id="mainContent"
      class="mainContent"
      v-if="path !== '/business-insight' && path !== '/user/assets/vip' && path !== '/deal-nav/calculter'"
      :class="path === '/' ? 'swiperHome' : ''"
      :style="{ 'padding-top': fixed ? '70px' : '' }"
    >
      <nuxt/>
    </div>

    <div class="businessInsight" v-if="path === '/business-insight'">

    </div>

    <div class="memberVip" v-if="path === '/user/assets/vip' || path === '/deal-nav/calculter'">
      <nuxt/>
    </div>

    <el-backtop class="backtop-layout" target="#__nuxt"></el-backtop>

    <!-- <div
        class="deal-center"
        v-if="isDealNavShow"
        @click="dealCenterClick"
        >
            交易中心
        </div> -->

    <daily-events></daily-events>

    <login v-if="showLoginFlag"/>
  </div>
</template>

<script>
import DailyEvents from "@components/sys/daily-events";
import {mapState, mapMutations} from "vuex";
import login from "@/components/sys/login.vue";

export default {
  components: {
    DailyEvents,
    login,
  },
  computed: {
    ...mapState({
      showLoginFlag: (state) => {
        return state.userinfo.showLoginFlag;
      },
      fixed: (state) => {
        return state.server.fixed;
      },
    }),
  },
  data() {
    return {
      isDealNavShow: false, //是否展示右下角交易中心按钮
      path: "",
      loading: false,
    };
  },
  watch: {
    "$route.path"(e) {
      var path = this.$route.path;
      this.path = path;
    },
  },
  methods: {
    dealCenterClick() {
      window.open(`/deal-nav`);
    },
  },
  mounted: function () {
    var path = this.$route.path;
    this.path = path;
    //  判断地址是否是以 "/deal-nav" 开头
    if (path.indexOf("/deal-nav") === 0) {
      // 如果是
      this.isDealNavShow = false;
    } else {
      // 如果不是
      this.isDealNavShow = true;
    }
    this.$store.dispatch("server/checkTime");
  },
};
</script>

<style scoped lang="scss">
.layout-default {
  background-color: #f5f7fd;
  width: 100%;
}

.mainContent {
  margin: 20px auto 0;
  padding-bottom: 20px;
}

.backtop-layout {
  width: 60px;
  height: 60px;
}

.deal-center {
  width: 60px;
  height: 60px;
  box-sizing: border-box;
  z-index: 1000;
  position: fixed;
  bottom: 120px;
  right: 40px;
  font-size: 14px;
  line-height: 1.2em;
  letter-spacing: 0.1em;
  background-color: #fff;
  padding: 14px 8px;
  border-radius: 50%;
  text-align: center;
  color: #1989fa;
  box-shadow: 0 0 6px #ccc;
  cursor: pointer;

  &:hover {
    background-color: #f2f6fc;
  }
}
</style>
